<template>
  <Catalogs
    title="Категории водительских прав"
    create-text="Новая"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'DriverLicenseCategoryAdd'"
    :route-edit="'DriverLicenseCategoryEdit'"
    :route-view="'DriverLicenseCategoryView'"
    :route-path="'/driver_license_categories'"
    :can-edit="canEditDriverLicenseCategoryCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "DriverLicenseCategories",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: false,
          class: 'driver-license-category-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: false,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'driver-license-category-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getDriverLicenseCategories(data);
    },
    canEditDriverLicenseCategoryCatalogs() {
      return this.hasPermission([PERM.CATALOG_DRIVER_LICENSE_CATEGORY_EDIT]);
    }
  }
}
</script>

<style>
.driver-license-category-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.driver-license-category-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/DriverLicenseCategories/DriverLicenseCategories.vue